import { Notifications } from "./notifications";
export class Ajax {
    constructor(url, method = "POST") {
        this.url = url;
        this.method = method;
        this.data = [];
    }
    send() {
        Ajax.loading = true;
        const options = {
            headers: {
                Accept: "application/json",
            },
            data: this.data,
            method: this.method,
            success: (data) => this.onSuccess(data),
            error: (data) => this.onError(data),
        };
        if (this.data instanceof FormData) {
            options.contentType = false;
            options.processData = false;
            options.cache = false;
        }
        $.ajax(this.url, options);
    }
    onSuccess(data) {
        if (data.error) {
            Notifications.error(data.message);
        }
        if (this.successCallback !== undefined) {
            this.successCallback(data);
        }
        Ajax.loading = false;
    }
    onError(data) {
        if (data.responseJSON && data.responseJSON.error) {
            Notifications.error(data.responseJSON.message);
        }
        if (this.errorCallback !== undefined) {
            this.errorCallback(data);
        }
        Ajax.loading = false;
    }
    static set loading(value) {
        if (value) {
            $("#loading").removeClass("hidden");
        }
        else {
            $("#loading").addClass("hidden");
        }
    }
}
